import React, { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import { SketchPicker } from "react-color";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { withSnackbar } from "notistack";
import { LABELS, WARNINGS } from "common/lables";
import {
  ListItemButton,
  ListItemIcon,
  Tooltip,
  Button,
  Popover,
} from "@mui/material";
import {
  RemoveRedEyeOutlined as RemoveRedEyeOutlinedIcon,
  AddRoadOutlined as AddRoadOutlinedIcon,
} from "@mui/icons-material";

import Scavenging from "components/Scavenging";
import StreetView from "components/StreetViewMap";

const MapLeftSideFilters = (props: any) => {
  const { setScavenging, scavenging, streetView, setStreetView } = props;

  return (
    <>
      <div>
        <div
          className="leftSideFilterOptions"
          style={{
            // position: scavenging || streetView ? "relative" : "absolute",
            top: streetView ? "1rem" : "7rem",
            left: scavenging || streetView ? "5.6rem" : "",
          }}
          onClick={() => {
            setScavenging(!scavenging);
            setStreetView(false);
          }}
        >
          <Tooltip title={LABELS.SCAVENGING} placement="right" arrow={true}>
            <ListItemButton>
              <ListItemIcon>
                <RemoveRedEyeOutlinedIcon />
              </ListItemIcon>
            </ListItemButton>
          </Tooltip>
        </div>
        <div
          className="leftSideFilterOptions"
          style={{
            top: streetView ? "4rem" : "10rem",
            left: scavenging || streetView ? "5.6rem" : "",
          }}
          onClick={() => {
            setStreetView(!streetView);
            setScavenging(false);
          }}
        >
          <Tooltip title={LABELS.STREET_VIEW} placement="right" arrow={true}>
            <ListItemButton>
              <ListItemIcon>
                <AddRoadOutlinedIcon />
              </ListItemIcon>
            </ListItemButton>
          </Tooltip>
        </div>
        {scavenging ? <Scavenging /> : streetView && <StreetView />}
      </div>
    </>
  );
};

export default withSnackbar(MapLeftSideFilters);
